export default {"src":"/_next/static/media/order-process-step4.2fd4020a.svg","height":97,"width":97,"blurWidth":0,"blurHeight":0};